// Pickups. P1 has XP motes dropped by dying enemies; collected when the player is
// within pickup range. (Magnet pull-in and other pickups arrive in P2/P3.)

import { Pool } from '../core/pool';
import { POOL_CAP } from './balance';

export interface XpMote {
  x: number;
  y: number;
  value: number;
}

function makeMote(): XpMote {
  return { x: 0, y: 0, value: 0 };
}

export const createMotePool = (): Pool<XpMote> => new Pool(POOL_CAP.motes, makeMote);

export function spawnMote(pool: Pool<XpMote>, x: number, y: number, value: number): void {
  const m = pool.acquire();
  if (m === null) return;
  m.x = x;
  m.y = y;
  m.value = value;
}

/** Verdant Still reward for killing a Rootling before its bloom resolves. */
export interface Nectar {
  x: number;
  y: number;
  lifeSec: number;
}

function makeNectar(): Nectar {
  return { x: 0, y: 0, lifeSec: 0 };
}

export const createNectarPool = (): Pool<Nectar> => new Pool(POOL_CAP.nectars, makeNectar);

export function spawnNectar(pool: Pool<Nectar>, x: number, y: number): void {
  const nectar = pool.acquire();
  if (nectar === null) return;
  nectar.x = x;
  nectar.y = y;
  nectar.lifeSec = 8;
}

/** Easy-mode recovery pickup. It stays put so collecting it remains a movement choice. */
export interface HealthOrb {
  x: number;
  y: number;
  lifeSec: number;
  healFrac: number;
}

function makeHealthOrb(): HealthOrb {
  return { x: 0, y: 0, lifeSec: 0, healFrac: 0 };
}

export const createHealthOrbPool = (): Pool<HealthOrb> =>
  new Pool(POOL_CAP.healthOrbs, makeHealthOrb);

export function spawnHealthOrb(
  pool: Pool<HealthOrb>,
  x: number,
  y: number,
  healFrac: number,
): void {
  if (healFrac <= 0) return;
  const orb = pool.acquire();
  if (orb === null) return;
  orb.x = x;
  orb.y = y;
  orb.lifeSec = 12;
  orb.healFrac = healFrac;
}
